<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Listado usuarios -->
        <v-data-table :loading="loading" :headers="headers" :items="usuarios" :items-per-page="15" dense
          class="elevation-3">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">USUARIOS</v-toolbar-title>
              <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider>
              <!-- Impresion usuario -->
              <v-btn icon small color="print" @click="crearPDF()" class="mr-1">
                <v-icon>print</v-icon>
              </v-btn>
              <!-- Fin Impresion usuario -->
              <v-spacer />
              <!-- Formulario busqueda de usuario -->
              <v-text-field class="mr-1 text-xs-center" v-model.trim="buscar" append-icon="search" dense label="Búsqueda"
                @keyup="listar()" single-line hide-details></v-text-field>
              <!-- Fin Formulario busqueda de usuario -->
              <v-spacer />
              <!-- Modal crear y modificar usuario -->
              <v-dialog v-model="dialog" max-width="500px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" class="hidden-sm-and-down" v-on="on" small outlined>Nuevo</v-btn>
                  <v-btn color="primary" class="hidden-md-and-up" v-on="on" fab x-small outlined>
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar dark dense class="primary" flat>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-row class="mt-2">
                        <v-col cols="12" sm="12">
                          <v-layout>
                            <template color="teal" v-if="file">
                              <v-avatar size="30px" class="mr-3">
                                <v-img :src="urlTemporal" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <template v-else-if="avatar == ''">
                              <v-avatar size="30px" class="mr-3">
                                <img :src="'data:image/png;base64,' + avatarxdefec" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <template color="teal" v-else>
                              <v-avatar size="30px" class="mr-3">
                                <img :src="'data:image/png;base64,' + avatar" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <input type="file" id="file" ref="boton" accept=".png, .jpg, .jpeg"
                              @change="buscarImagen($event)" class="d-none" />
                            <v-text-field dense v-model.trim="nombre" label="Nombres y Apellidos"
                              :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 3 && v.length <= 80) || 'Nombre debe tener entre 3 a 80 caracteres', Rules.unespacio]"
                              maxlength="80" v-uppercase hide-details></v-text-field>
                          </v-layout>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select dense v-model="idrol" :items="roles" label="Rol"
                            :rules="[v => !!v || 'El rol es requerido']" @change="cierre = false" hide-details>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select dense v-model="idsucursal" :items="selectSucursales" label="Establecimiento"
                            :rules="[v => !!v || 'La sucursal es requerido']" hide-details></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="num_documento" label="Numero Documento"
                            :rules="[v => !!v || 'Numero Documento requerido', v => (!!v && v.length == 8) || 'El numero debe tener 8 caracteres']"
                            maxlength="8" prepend-inner-icon="featured_play_list" @keypress="common.isNum($event)"
                            hide-details>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="telefono" label="Telefono"
                            :rules="[v => !!v || 'Telefono requerido', v => v.length == 9 || 'El Telefono debe tener 9 caracteres']"
                            maxlength="9" prepend-inner-icon="phone" v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field dense v-model.trim="direccion" label="Direccion"
                            :rules="[v => !!v || 'Dirección requerido', v => (!!v && v.length >= 8 && v.length <= 60) || 'La dirección no debe tener entre 8 a 60 caracteres', Rules.unespacio]"
                            maxlength="60" prepend-inner-icon="place" v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field dense v-model.trim="email" label="Email"
                            :rules="[v => /.+@.+\..+/.test(v) || 'El email debe ser válido', Rules.sinespacio]"
                            maxlength="50" prepend-inner-icon="mail" v-lowercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field dense v-model="password" label="Password"
                            :rules="[v => !!v || 'Password requerido', v => v.length >= 8 || 'El password debe tener mas de 8 caracteres']"
                            maxlength="30" :append-icon="mostrarpassword ? 'visibility' : 'visibility_off'"
                            :type="mostrarpassword ? 'text' : 'password'"
                            @click:append="mostrarpassword = !mostrarpassword" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-checkbox v-model="cierre"
                            v-if="editedIndex == 1 && idrol == 1 || editedIndex == 1 && idrol == 4"
                            label="Habilitar Cierre de Caja" hide-details></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 px-4 justify-center">
                    <v-btn color="error" @click="close" small outlined>
                      <v-icon left>close</v-icon>Cancelar
                    </v-btn>
                    <v-btn color="primary" @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid"
                      small outlined>
                      <v-icon left>check</v-icon>Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear y modificar usuario -->

              <!-- Modal activar, desactivar usuario -->
              <v-dialog v-model="adModal" max-width="290">
                <v-card>
                  <v-card-title class="justify-center" v-if="adAccion == 1">¿Activar Usuario?</v-card-title>
                  <v-card-title class="justify-center" v-if="adAccion == 2">¿Desactivar Usuario?</v-card-title>
                  <v-card-text>
                    Estás a punto de
                    <span v-if="adAccion == 1">Activar</span>
                    <span v-if="adAccion == 2">Desactivar</span>
                    el Usuario {{ adNombre }}
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn color="success" @click="activarDesactivarCerrar" small outlined>Cancelar</v-btn>
                    <v-btn v-if="adAccion == 1" color="info" @click="activar" small outlined>Activar</v-btn>
                    <v-btn v-if="adAccion == 2" color="info" @click="desactivar" small outlined>Desactivar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal activar, desactivar usuario -->
            </v-toolbar>
          </template>
          <!-- Opciones editar, eliminar usuario -->
          <template v-slot:item.avatar="{ item }">
            <template>
              <v-avatar size="30">
                <img :src="'data:image/png;base64,' + item.avatar" />
              </v-avatar>
            </template>
          </template>
          <template v-slot:item.fecha_ingreso="{ item }">
            <span>{{ item.fecha_ingreso | formatearFecha }}</span>
          </template>

          <template v-slot:item.accion="{ item }">
            <v-btn small icon>
              <v-icon color="primary" @click="editItem(item)">edit</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.condicion="{ item }">
            <template v-if="item.condicion">
              <v-btn text small color="success" @click="activarDesactivarMostrar(2, item)">Activo</v-btn>
            </template>
            <template v-else>
              <v-btn text small color="info" @click="activarDesactivarMostrar(1, item)">Inactivo</v-btn>
            </template>
          </template>
          <!-- Fin Opciones editar, eliminar usuario -->
        </v-data-table>
        <!-- Fin Listado usuarios -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import jsPDF from "jspdf";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      usuarios: [],
      dialog: false,
      headers: [
        { text: "CdUs", value: "idusuario", sortable: false },
        { text: "AVATAR", value: "avatar", sortable: false },
        { text: "NOMBRE", value: "nombre", sortable: false },
        { text: "DNI", value: "num_documento", sortable: false },
        { text: "FEC.INGR.", value: "fecha_ingreso", sortable: false },
        //{ text: "EMAIL", value: "email", sortable: false },
        { text: "ROL", value: "rol", sortable: false },
        { text: "ESTABLECIMIENTO", value: "sucursal", sortable: false },
        { text: "CONDICIÓN", value: "condicion", sortable: false },
        { text: "OPC.", value: "accion", sortable: false, width: 50 },
      ],
      loading: false,

      buscar: "",
      editedIndex: -1,
      id: "",
      idrol: "",
      roles: [],
      idsucursal: "",
      selectSucursales: [],
      nombre: "",
      tipo_documento: "",
      num_documento: "",
      direccion: "",
      telefono: "",
      email: "",
      avatar: "",
      password: "",
      act_password: false,
      passwordAnt: "",

      cierre: false,

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      file: null,
      urlTemporal: "",

      desabilitar: false,

      isValid: true,
      mostrarpassword: false,

      avatarxdefec:
        "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",

      /* Validaciones */
      Rules: {
        sinespacio: (v) =>
          (v || "").indexOf(" ") < 0 || "No se permite espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },

  computed: {
    ...mapState(["logo"]),

    formTitle() {
      return this.editedIndex === -1 ? "Nuevo usuario" : "Actualizar usuario";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.select();
  },
  methods: {
    ...mapActions(["snackBar"]),

    /* Listar usuarios */
    listar() {
      let me = this;

      me.loading = true;
      axios.get("api/Usuarios/ListarUsuarioFiltro", {
        params: {
          buscar: me.buscar == "" ? "-" : me.buscar,
        },
      })
        .then(function (response) {
          //console.log(response);
          me.usuarios = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    /* Seleccionar roles, sucursal, etc */
    select() {
      let me = this;

      var rolesArray = [];
      axios.get("api/Roles/Select")
        .then(function (response) {
          rolesArray = response.data;
          rolesArray.map(function (x) {
            me.roles.push({ text: x.nombre, value: x.idrol });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });

      let su = this;
      var sucursalesArray = [];
      axios.get("api/Sucursales/Select")
        .then(function (response) {
          sucursalesArray = response.data;
          sucursalesArray.map(function (x) {
            su.selectSucursales.push({ text: x.nombre, value: x.idsucursal });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    /* Editar y guardar usuario */
    guardar() {
      let me = this;
      me.desabilitar = true;

      if (this.editedIndex > -1) {
        axios.put("api/Usuarios/Actualizar", {
          idusuario: me.id,
          nombre: me.nombre,
          idrol: me.idrol,
          idsucursal: me.idsucursal,
          num_documento: me.num_documento,
          direccion: me.direccion,
          telefono: me.telefono,
          email: me.email,
          avatar: me.avatar == "" ? me.avatarxdefec : me.avatar,
          password: me.password,
          act_password: me.password != me.passwordAnt ? true : false,
          cierre: me.cierre,
        })
          .then(function (response) {
            me.desabilitar = false;
            me.snackBar({ cl: "success", msg: response.data });
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      } else {
        axios.post("api/Usuarios/Crear", {
          nombre: me.nombre,
          idrol: me.idrol,
          idsucursal: me.idsucursal,
          num_documento: me.num_documento,
          direccion: me.direccion,
          telefono: me.telefono,
          email: me.email,
          avatar: me.avatar == "" ? me.avatarxdefec : me.avatar,
          password: me.password,
        })
          .then(function (response) {
            me.desabilitar = false;
            me.snackBar({ cl: "success", msg: response.data });
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      }
    },

    /* Buscar imagen usuario */
    buscarImagen(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 150px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes =
              dataURI.split(",")[0].indexOf("base64") >= 0
                ? atob(dataURI.split(",")[1])
                : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            //return dataURItoBlob(dataUrl);
            return dataUrl;
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 150,
        })
          .then((resizedImage) => {
            this.avatar = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },

    /* Editar usuario item */
    editItem(item) {
      this.id = item.idusuario;
      this.idrol = item.idrol;
      this.idsucursal = item.idsucursal;
      this.nombre = item.nombre;
      this.num_documento = item.num_documento;
      this.direccion = item.direccion;
      this.telefono = item.telefono;
      this.email = item.email;
      this.avatar = item.avatar;
      this.password = item.password_hash;
      this.passwordAnt = item.password_hash;
      this.editedIndex = 1;
      this.dialog = true;
    },

    /* Cerrar ventana usuario */
    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.idrol = "";
      this.idsucursal = "";
      this.nombre = "";
      this.num_documento = "";
      this.direccion = "";
      this.telefono = "";
      this.email = "";
      this.avatar = "";
      this.password = "";
      this.passwordAnt = "";
      this.act_password = false;
      this.file = null;
      this.urlTemporal = "";
      this.cierre = false; // Desabilitamos
      this.mostrarpassword = false;
      // Limpiamos input carga de imagen
      document.getElementById("file").value = [];

      this.editedIndex = -1;
    },

    /* Desactivar, activar usuario */
    desactivar() {
      let me = this;

      axios.put("api/Usuarios/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.nombre;
      this.adId = item.idusuario;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    activar() {
      let me = this;

      axios.put("api/Usuarios/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar usuario */

    crearPDF() {
      var columns = [
        { header: "COD", dataKey: "idusuario" },
        { header: "NOMBRE", dataKey: "nombre" },
        { header: "ESTABLECIMIENTO", dataKey: "sucursal" },
        { header: "DOCUMENTO", dataKey: "num_documento" },
        { header: "DIRECCIÓN", dataKey: "direccion" },
        { header: "TELEFONO", dataKey: "telefono" },
        { header: "EMAIL", dataKey: "email" },
        { header: "C", dataKey: "condicion" },
      ];
      var body = [];

      this.usuarios.map(function (x) {
        body.push({
          idusuario: x.idusuario,
          nombre: x.nombre,
          sucursal: x.sucursal,
          num_documento: x.num_documento,
          direccion: x.direccion,
          telefono: x.telefono,
          email: x.email,
          condicion: x.condicion == 1 ? "A" : "I",
        });
      });
      //console.log(body);
      // Titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text("LISTADO DE USUARIOS", doc.internal.pageSize.width / 2, 45, {
            align: "center",
          });
          doc.addImage(imgData, "JPEG", 40, 17, 70, 49.39);
        }
      };
      // Pie de pagina
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
        }
      };

      // Configurando hoja
      var imgData = "data:image/png;base64," + this.logo;
      var doc = new jsPDF("p", "pt");

      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 8 },
        columnStyles: {
          idusuario: { cellWidth: 30, halign: "center" },
          nombre: { cellWidth: 100.18 },
          sucursal: { cellWidth: 50 },
          num_documento: { cellWidth: 55 },
          direccion: { cellWidth: 100 },
          telefono: { cellWidth: 70 },
          email: { cellWidth: 80 },
          condicion: { cellWidth: 30, halign: "center" },
        },
      });

      addHeaders(doc);
      addFooters(doc);
      doc.save("Usuarios.pdf");
    },

  },
};
</script>
